import React from "react";
import styled, { keyframes, css } from "styled-components";


function Partners() {
    const row1 = [
        "../../assets/image/partner_0.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/b2bd91d7b87b2181ca45.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6591cdc0702b32310306.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/3b7d9f4b073deb6a9b74.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/3cd767dea94a85078ca4.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/a2b3c3709ffedce2a22a.png",
    ];

    const row2 = [
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6c585c33ca6c71c79bb7.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/9dd55e54b5a28658bf4e.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/0384060dcbf73b6a707c.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/35e044b3354aaa0caed5.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/f50ae7cbf6cc805bdadc.png",
        "https://assets.algoexpert.io/spas/main/prod/g523bdeb478-prod/dist/images/6c585c33ca6c71c79bb7.png",
    ];

    return (
        <AppContainer>
            <Wrapper>
                <Marquee>
                    <MarqueeGroup>
                        {['', '', '', '', '', '', '', ''].map((el, index) => (
                            <ImageGroup>
                                <Image src={require(`../../assets/image/partner_${index}.png`)} />
                            </ImageGroup>
                        ))}
                    </MarqueeGroup>
                    <MarqueeGroup>
                        {['', '', '', '', '', '', '', ''].map((el, index) => (
                            <ImageGroup>
                                <Image src={require(`../../assets/image/partner_${index}.png`)} />
                            </ImageGroup>
                        ))}
                    </MarqueeGroup>
                </Marquee>
                <Marquee style={{ marginTop: "10px" }}>
                    <MarqueeGroup2>
                        {['', '', '', '', '', '', ''].map((el, index) => (
                            <ImageGroup>
                                <Image src={require(`../../assets/image/partner_${index + 8}.png`)} />
                            </ImageGroup>
                        ))}
                    </MarqueeGroup2>
                    <MarqueeGroup2>
                        {['', '', '', '', '', '', ''].map((el, index) => (
                            <ImageGroup>
                                <Image src={require(`../../assets/image/partner_${index + 8}.png`)} />
                            </ImageGroup>
                        ))}
                    </MarqueeGroup2>
                </Marquee>
            </Wrapper>
        </AppContainer>
    );
}

export default Partners;

const AppContainer = styled.div`
  color: #000000;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
    @media (max-width: 600px) {
    display:none;
    }
`;

const Wrapper = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const Marquee = styled.div`
  display: flex;
  overflow: hidden;
  user-select: none;
  mask-image: linear-gradient(
    to right,
    hsl(0 0% 0% / 0),
    hsl(0 0% 0% / 1) 10%,
    hsl(0 0% 0% / 1) 90%,
    hsl(0 0% 0% / 0)
  );
`;

const scrollX = keyframes`
  from {
    left: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

const common = css`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  white-space: nowrap;
  width: 150%;
  animation: ${scrollX} 60s linear infinite;
    @media (max-width: 600px) {
    width: 275%;
    }
`;

const MarqueeGroup = styled.div`
  ${common}
`;
const MarqueeGroup2 = styled.div`
  ${common}
  animation-direction: reverse;
  animation-delay: -3s;
`;

const ImageGroup = styled.div`
  display: grid;
  place-items: center;
   @media (max-width: 600px) {
     margin-left:15px;
     margin-right:15px
    }


`;

const Image = styled.img`
  object-fit: contain;
  width: 100%;
  height: 60px;
`;